module.exports = __webpack_public_path__ + "img/hamburger-button-white.8ae536ef.svg";